module.exports = __webpack_public_path__ + "static/img/3.1.b7c6f36e.png";